import React from 'react';

import styles from './BorderT1.module.css';

export const BorderT1 = ({ children, className }) => {
  return <div className={`${styles.container} ${className}`}>{children}</div>;
};
